export interface DataPoint {
  id: number;
  measureCode: string;
  periodCode: string;
  date: Date;
  value: number;
  sentiment: Sentiment;
}

export enum Sentiment {
  Positive = 1,
  Negative = -1,
  Neutral = 0,
}
